import styled from "styled-components";

export const FilterButtonSelected = "padding: 2px 8px; filter: brightness(0.5);";

export const FilterButton = "padding: 2px 8px;";

export const FormFieldsOnRight = "@media(min-width: 600px) { margin-left: 8px; }";

export const WrapTextWithoutLineClamp = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
  white-space: normal;
`;
